(function ($) {
    // Pinned header and contact tab

    var currentScroll = $(window).scrollTop();

    if (currentScroll > 0) {
        $('.m-header').addClass('m-header--scrolled');
    } else {
        $('.m-header').removeClass('m-header--scrolled');
    }

    $(window).scroll(function () {
        var currentScroll = $(window).scrollTop();

        if (currentScroll > 0) {
            $('.m-header').addClass('m-header--scrolled');
        } else {
            $('.m-header').removeClass('m-header--scrolled');
        }

        if (currentScroll > 100) {
            $('.m-contact__tab').addClass('m-contact__tab--isactive');
        } else {
            $('.m-contact__tab').removeClass('m-contact__tab--isactive');
        }
    });

    // ScrollMagic

    var controller = new ScrollMagic.Controller();

    // Accordions

    $('.m-flexible-accordions__items').each(function () {
        var tween = new TimelineMax().staggerFrom(
            $(this).children(),
            0.3,
            { opacity: 0, y: 20 },
            0.3
        );

        var scene = new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.7,
            reverse: false,
        })
            .setTween(tween)
            .addTo(controller);
    });

    // Attractors

    $('.m-flexible-attractors__items').each(function () {
        var tween = new TimelineMax().staggerFrom(
            $(this).children(),
            0.3,
            { opacity: 0, y: 20 },
            0.3
        );

        var scene = new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.7,
            reverse: false,
        })
            .setTween(tween)
            .addTo(controller);
    });

    // Columns

    $('.m-flexible-columns img').each(function () {
        var tween = new TimelineMax().to($(this), 0.3, {
            opacity: 1,
            scale: 1,
        });

        var scene = new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.7,
            reverse: false,
        })
            .setTween(tween)
            .addTo(controller);
    });

    // Downloads

    $('.m-flexible-downloads ul').each(function () {
        var tween = new TimelineMax().staggerFrom(
            $(this).children(),
            0.3,
            { opacity: 0, y: 20 },
            0.3
        );

        var scene = new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.7,
            reverse: false,
        })
            .setTween(tween)
            .addTo(controller);
    });

    // Attractors

    $('.m-flexible-logos__items').each(function () {
        var tween = new TimelineMax().staggerFrom(
            $(this).children(),
            0.1,
            { opacity: 0, y: 20 },
            0.1
        );

        var scene = new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.7,
            reverse: false,
        })
            .setTween(tween)
            .addTo(controller);
    });

    // Tweets

    $('.m-twitter__tweets').each(function () {
        var tween = new TimelineMax().staggerFrom(
            $(this).children(),
            0.3,
            { opacity: 0, y: 20 },
            0.3
        );

        var scene = new ScrollMagic.Scene({
            triggerElement: this,
            triggerHook: 0.7,
            reverse: false,
        })
            .setTween(tween)
            .addTo(controller);
    });
})(jQuery);
